import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const LIST_AMENITIES = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}

  query listAmenities {
    fetchAmenities {
      ... on AttributesOutput {
        attributes {
          name
          id
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
